import { Injectable } from '@angular/core';
import { Subject } from "rxjs/Subject";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class MensajeProvider {

  private init:number = 450;
  private source = new BehaviorSubject<number>(this.init);
  public llamarevento$ = this.source.asObservable();

  constructor() { }

  restartCountdown(init?){
    this.source.next(init);
  }

}


// WEBPACK FOOTER //
// ./src/providers/mensaje/mensaje.ts